import { Accordion } from '../../../../../components/general/accordion';
import FlagIcon from '@mui/icons-material/Flag';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { PqrProductDataProps } from './props';
import { usePqrProductData } from './hook';

export const PqrProductData = ({ productData }: PqrProductDataProps) => {
    const { formik } = usePqrProductData(productData);

    return (
        <Accordion
            title="DATOS PRODUCTO"
            icon={<FlagIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Póliza"
                        name="policy"
                        size="small"
                        value={formik.values.policy}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Valor de la prima"
                        name="bonusValue"
                        size="small"
                        value={formik.values.bonusValue}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Placa"
                        name="plate"
                        size="small"
                        value={formik.values.plate}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
